module.exports = __webpack_public_path__ + "img/Logo-7.3636ca77.svg";